export default __webpack_public_path__ + "static/media/diesel_down_black.0b836668.jpg";